export const NOT_ACCEPTED_RULES_IDS = {
  3547: "/rules/5",
  3546: "/rules/4",
  3545: "/rules/3",
  3543: "/rules/1",
  3413: "/rules/4",
  3548: "/rules/6"
};
